import React from "react"

import "./featured-autopauta.scss"

const FeaturedAutopauta = props => {
  return (
    <a href={props.item.botonRedireccion} className="f-featured-autopauta">
      <img
        className="f-featured-autopauta-img"
        alt={props.item.imagenDestacadaDelGrid[0].description}
        src={
          props.mobile
            ? props.item.imagenDestacadaDelGrid[1].file.url
            : props.item.imagenDestacadaDelGrid[0].file.url
        }
      />
    </a>
  )
}
export default FeaturedAutopauta
